import { Link, useLocation } from "react-router-dom";
import { FileText } from "lucide-react";

// Brand primary color (kept in sync with LandingPage / PnbpPage).
const PRIMARY = "#1B5189";

type NavItem = { label: string; to: string };

const NAV: NavItem[] = [
  { label: "Beranda", to: "/" },
  // { label: "Feature", to: "/features" }, // disabled per stakeholder feedback; uncomment to restore
  { label: "Taksonomi", to: "/taksonomi" }, // replaces the Fitur tab
  { label: "PNBP", to: "/pnbp" },
  { label: "Stakeholder", to: "/stakeholder" },
];

/**
 * Shared public-facing header with brand logo, navigation, and Login button.
 * Used on the landing page and the public PNBP page so visitors can move
 * between them without losing context.
 */
export default function PublicHeader() {
  const { pathname } = useLocation();

  return (
    <header className="sticky top-0 z-40 border-b border-slate-200 bg-white/90 backdrop-blur">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        <Link to="/" className="flex items-center gap-3">
          <div
            className="flex h-10 w-10 items-center justify-center rounded-lg text-white shadow-sm"
            style={{ backgroundColor: PRIMARY }}
          >
            <FileText className="h-5 w-5" />
          </div>
          <div className="leading-tight">
            <div className="text-base font-bold" style={{ color: PRIMARY }}>
              AI - PNBP
            </div>
            <div className="text-xs text-slate-500">
              Arsitektur Informasi PNBP
            </div>
          </div>
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          {NAV.map((item) => {
            const isActive = pathname === item.to;
            return (
              <Link
                key={item.to}
                to={item.to}
                className={`text-sm transition ${
                  isActive
                    ? "font-semibold"
                    : "font-medium text-slate-600 hover:opacity-80"
                }`}
                style={isActive ? { color: PRIMARY } : undefined}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>

        {/* <Link
          to="/login"
          className="rounded-lg px-5 py-2 text-sm font-medium text-white shadow-sm transition hover:opacity-90"
          style={{ backgroundColor: PRIMARY }}
        >
          Login
        </Link> */}
      </div>
    </header>
  );
}
